import React from "react";
import { Navigate } from "react-router-dom";
import MetaTitle from "../components/documents/MetaTitle";

const FreeAuthRoute = ({ auth, children, title = "" }) => {
  const token = localStorage.getItem("auth_token");

  if (token) {
    return <Navigate to="/" />;
  } else {
    return (
      <>
        <MetaTitle title={`Crowdfunding | ${title}`} />
        {children}
      </>
    );
  }
};

export default FreeAuthRoute;
